// extracted by mini-css-extract-plugin
export var modal = "_t0-0";
export var table = "_t0-1";